import { TranslatePipe } from '../../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../../utils/session.service';
import RestService from '../../../services/core-rest.service';
import PreVisitRecordTicketForPersonService from '../../../services/pre-visit-record-ticket-for-person.service';
import DialogServices from '../../../services/dialog.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';
import RoutingService from '../../../services/routing.service';
import Toast from '../../../services/toast.service';
import IdCodeUtil from '../../../utils/id-code-util.service';
import { ModalCreateUserComponent } from '../../../components/pre-visit/record-ticket-for-person/modal-create-user/modal-create-user.component';
import { ModalGiveConsentsComponent } from '../../../components/pre-visit/record-ticket-for-person/modal-give-consents/modal-give-consents.component';

@Component({
	standalone: true,
	selector: 'pre-visit-record-ticket-for-person',
	templateUrl: './pre-visit-record-ticket-for-person.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export default class PreVisitRecordTicketForPersonComponent implements OnInit {
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private dialogServices: DialogServices = inject(DialogServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private idCodeUtil: IdCodeUtil = inject(IdCodeUtil);
	private toast: Toast = inject(Toast);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('preVisitDashboard').then(() => {
			this.onResolve();
		});
	};
	
	onResolve() {
		this.vm.userEstonianIdentificationCode = "";
		this.vm.isValidatePatientStep1 = true;
		this.vm.isValidatePatientStep2 = false;
		this.vm.isValidateRecorderStep1 = false;
		this.vm.isValidateRecorderStep2 = false;
		this.vm.showCreateUserButton = false;
		this.vm.isInsuranceDataNotFound = false;
		this.vm.requesterGpNotFound = false;
		this.vm.showIdentifierDoesNotValidate = false;
		this.vm.isUserConsentsNotGiven = false;
		this.vm.loading = true;
		this.vm.authType = 'SMART_ID';
		this.vm.callerRole = {};
		this.vm.requesterRelationshipToPatient = "";
		
		this.vm.user = this.session.getSession().user;
		this.vm.mispPhone = this.vm.user.phone;
		
		this.preVisitRecordTicketForPersonService.clearData();
		this.preVisitRecordTicketForPersonService.setRequestRecorder(this.session.getSession());
		
		this.vm.validatePatientIdentifier = this.validatePatientIdentifier;
		this.vm.validateRequesterIdentifier = this.validateRequesterIdentifier;
		this.vm.searchUserByIdCode = this.searchUserByIdCode;
		this.vm.cantUseServiceReasonPicker = this.cantUseServiceReasonPicker;
		this.vm.showCreateUserModel = this.showCreateUserModel;
		this.vm.showGiveConsentsModel = this.showGiveConsentsModel;
		this.vm.startMispAuth = this.startMispAuth;
		this.vm.openMyTickets = this.openMyTickets;
		
		this.loadMispSessionStatus();
	}
	
	loadMispSessionStatus() {
		this.restService.getPreVisitMispSessionStatus()
			.then((response) => {
				this.vm.mispAuthCompleted = true;
				this.vm.loading = false;
			})
			.catch((response) => {
				if (response.error.errorCode === 'NO_MISP_SESSION') {
					this.vm.mispAuthRequired = true;
					this.vm.loading = false;
				}
			});
	}
	
	startMispAuth() {
		if (this.vm.mispAuthStarted) {
			return;
		}
		this.vm.mispAuthFailed = false;
		this.vm.mispAuthStarted = true;
		this.vm.loading = true;
		var payload: any = {
			phoneNumber: this.vm.mispPhone
		};
		
		var startApi = this.vm.authType === 'SMART_ID' ?
			this.restService.savePreVisitMispSmartIdAuthStart(payload)
			:
			this.restService.savePreVisitMispMobileIdAuthStart(payload);
		
		startApi
			.then((response) => {
				this.vm.mispControlCode = response.verificationCode;
				this.vm.mispSessionId = response.sessionID;
				this.vm.loading = false;
				// this.vm.startPolling
				this.pollAuthStatus();
			}).catch((error) => {
				console.error(error);
				this.vm.mispAuthStarted = false;
				this.vm.mispAuthFailed = true;
				this.vm.loading = false;
			});
	}
	
	pollAuthStatus() {
		var statusApi = this.vm.authType === 'SMART_ID' ?
			this.restService.getPreVisitMispSmartIdAuthStatus({ 'sessionID': this.vm.mispSessionId })
			:
			this.restService.getPreVisitMispMobileIdAuthStatus({ 'sessionID': this.vm.mispSessionId });
		
		statusApi
			.then((response) => {
				if (response.status == 'ACTIVE') {
					this.stopAuthPoll();
					this.vm.mispAuthRequired = false;
					this.vm.mispAuthStarted = false;
					this.vm.mispControlCode = null;
					this.vm.mispSessionId = null;
					this.vm.loading = false;
				} else if (response.status == 'CANCELLED') {
					this.stopAuthPoll();
					this.vm.mispControlCode = null;
					this.vm.mispSessionId = null;
					this.vm.mispAuthStarted = false;
					this.vm.mispAuthFailed = true;
					this.vm.loading = false;
				} else {
					this.vm.mispAuthStatusInterval = this.angularHelperService.createTimer(() => {
						this.pollAuthStatus();
					}, 10000);
				}
			}).catch((error) => {
				console.error(error);
				this.stopAuthPoll();
				this.vm.mispAuthStarted = false;
				this.vm.mispAuthFailed = true;
				this.vm.loading = false;
			});
	}
	
	stopAuthPoll() {
		if (this.vm.mispAuthStatusInterval) this.angularHelperService.cancelTimer(this.vm.mispAuthStatusInterval);
	}
	
	validatePatientIdentifier() {
		this.vm.showIdentifierDoesNotValidate = false;
		this.vm.isUserConsentsNotGiven = false;
		this.vm.userEstonianIdentificationCode = (this.vm.userEstonianIdentificationCode || "").trim();
		if (!this.idCodeUtil.isValid(this.vm.userEstonianIdentificationCode)) {
			this.vm.showIdentifierDoesNotValidate = true;
			return;
		}
		
		if (this.vm.isValidatePatientStep2) {
			this.vm.validatePatientStep2Invalid = false;
			if (this.vm.callerRole === 'isRepresenter') {
				this.vm.userEstonianIdentificationCode = "";
				
				this.vm.isValidatePatientStep1 = false;
				this.vm.isValidateRecorderStep1 = true;
			} else if (this.vm.callerRole === 'isPatient') {
				this.vm.loading = true;
				this.restService.updateSessionPreVisitRecordForPatientSetPatientAsRequester()
					.then(() => {
						this.preVisitRecordTicketForPersonService.setRequester(this.preVisitRecordTicketForPersonService.getPatient());
						this.angularRoutingHelperService.setPath('/pre-visit');
						this.vm.loading = false;
					})
					.catch((error) => {
						console.log(error);
						this.vm.loading = false;
					});
			} else {
				this.vm.validatePatientStep2Invalid = true;
			}
		} else {
			this.vm.loading = true;
			this.searchUserByIdCode(this.vm.userEstonianIdentificationCode, 'PATIENT')
				.then((response) => {
					if (response.errorCode === 'USER_DOES_NOT_EXIST') {
						this.vm.showCreateUserButton = true;
					} else {
						this.vm.isValidatePatientStep2 = true;
						this.preVisitRecordTicketForPersonService.setPatient(response);
					}
					this.vm.loading = false;
				})
				.catch((error) => {
					if (error.error.errorCode === 'CONSENT_NOT_GIVEN_TO_INSURANCE_DATA') {
						this.vm.isUserConsentsNotGiven = true;
					}
					if (error.error.errorCode === 'INSURANCE_INFO_NOT_FOUND') {
						this.vm.isInsuranceDataNotFound = true;
					}
					if (error.error.errorCode === 'NO_MISP_SESSION') {
						this.toast.show('NO_MISP_SESSION');
						this.vm.mispAuthRequired = true;
					}
					this.vm.loading = false;
					console.log(error);
				});
		}
	}
	
	openMyTickets() {
		this.angularRoutingHelperService.setPath('/bookings/service-provider-pre-visit');
	}
	
	validateRequesterIdentifier() {
		this.vm.showIdentifierDoesNotValidate = false;
		this.vm.isUserConsentsNotGiven = false;
		this.vm.requesterGpNotFound = false;
		this.vm.userEstonianIdentificationCode = (this.vm.userEstonianIdentificationCode || "").trim();
		if (!this.idCodeUtil.isValid(this.vm.userEstonianIdentificationCode)) {
			this.vm.showIdentifierDoesNotValidate = true;
			return;
		}
		if (this.vm.isValidateRecorderStep2) {
			if (this.vm.requesterRelationshipToPatient) {
				this.vm.noConnectionDefined = false;
				this.preVisitRecordTicketForPersonService.setRequesterRelationshipToPatient(this.vm.requesterRelationshipToPatient);
				this.angularRoutingHelperService.setPath('/pre-visit');
			} else {
				this.vm.noConnectionDefined = true;
				this.vm.loading = false;
			}
		} else {
			this.vm.loading = true;
			this.searchUserByIdCode(this.vm.userEstonianIdentificationCode, 'REQUESTER')
				.then((response) => {
					if (response.errorCode === 'USER_DOES_NOT_EXIST') {
						this.vm.showCreateUserButton = true;
					} else {
						this.preVisitRecordTicketForPersonService.setRequester(response);
						this.vm.isValidateRecorderStep2 = true;
					}
					this.vm.loading = false;
				})
				.catch((error) => {
					if (error.error.errorCode === 'CONSENT_NOT_GIVEN_TO_INSURANCE_DATA') {
						this.vm.isUserConsentsNotGiven = true;
					}
					if (error.error.errorCode === 'INSURANCE_INFO_NOT_FOUND') {
						this.vm.isInsuranceDataNotFound = true;
					}
					if (error.error.errorCode === 'NO_MISP_SESSION') {
						this.toast.show('NO_MISP_SESSION');
						this.vm.mispAuthRequired = true;
					}
					if (error.error.errorCode === 'REQUESTER_GP_NOT_FOUND') {
						this.vm.requesterGpNotFound = true;
					}
					console.log(error);
					this.vm.loading = false;
				});
		}
	}
	
	searchUserByIdCode(userIdentifierCode, userType) {
		return this.restService.getPreVisitRecordForPatientValidateUser({'userIdentifierCode': userIdentifierCode, 'userType': userType})
	}
	
	showCreateUserModel() {
		var dialog = this.dialogServices.show({
			controller: ModalCreateUserComponent,
			userEstonianIdentificationCode: this.vm.userEstonianIdentificationCode,
			isPatient: this.vm.isValidatePatientStep1
		});
		dialog.afterClosed().subscribe(
			(user) => {
				if (user && this.vm.isValidatePatientStep1) {
					this.preVisitRecordTicketForPersonService.setPatient(user);
					this.vm.isValidatePatientStep2 = true;
				} else if (user && this.vm.isValidateRecorderStep1) {
					this.vm.isValidateRecorderStep2 = true;
				}
				this.vm.showCreateUserButton = false;
			},
			() => {
				this.vm.showCreateUserButton = false;
			}
		);
	}
	
	showGiveConsentsModel() {
		var dialog = this.dialogServices.show({
			controller: ModalGiveConsentsComponent,
			userEstonianIdentificationCode: this.vm.userEstonianIdentificationCode,
			isPatient: this.vm.isValidatePatientStep1
		});
		dialog.afterClosed().subscribe(
			user => {
				this.vm.validatePatientIdentifier();
				this.vm.isUserConsentsNotGiven = false;
			},
			() => {
				this.vm.isUserConsentsNotGiven = true;
			}
		);
	}
	
	cantUseServiceReasonPicker() {
		if (!this.vm.businessService && this.vm.isInsured) {
			return this.vm.cantUseServiceReasons['DOCTOR_NOT_JOINED'];
		} else if (!this.vm.isInsured && this.vm.businessService && this.vm.businessService.preVisitEnabled) {
			return this.vm.cantUseServiceReasons['NO_ACTIVE_EHIF_INSURANCE'];
		} else if (!this.vm.isInsured && !this.vm.businessService && this.vm.userPatientListCode) {
			return this.vm.cantUseServiceReasons['DOCTOR_NOT_JOINED'];
		} else if (!this.vm.isInsured && !this.vm.userPatientListCode) {
			return this.vm.cantUseServiceReasons['NOT_PART_OF_ANY_PATIENT_LISTING'];
		} else if (this.vm.businessService && !this.vm.businessService.preVisitEnabled) {
			return this.vm.cantUseServiceReasons['DOCTOR_JOINED_BUT_PRE_VISIT_DISABLED'];
		}
		return '';
	}
	
}